import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { toOrganizationTree } from "src/app/_helpers/org-tree-helper";
import { OrganizationLevel } from "src/app/models/organizationLevel.model";
import { OrganizationLevelService } from "src/app/services/organizationLevel.service";
import { usersRouteConfig } from "src/app/shared/constants/usersRouteConfig.constants";

import { trackById } from "src/app/shared/utils/track-by.util";
@Component({
  standalone: false,
    selector: "app-organizations",
    templateUrl: "./organizations.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: [
        "./../../shared/grid/core-grid/core-grid.component.scss",
        "./organizations.component.scss",
    ],
})
export class OrganizationsComponent implements OnInit, OnDestroy {
    tabs = usersRouteConfig;
    organizationLevels: OrganizationLevel[] = [];
    organizationsTree: OrganizationLevel[];
    private destroy$ = new Subject<void>();

    constructor(private organizationLevelService: OrganizationLevelService) {}

    ngOnInit(): void {
        this.setOrganizations();
        this.organizationLevelService.organizationsUpdated
            .pipe(takeUntil(this.destroy$))
            .subscribe((res) => {
                if (res) this.setOrganizations();
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    setOrganizations() {
        this.organizationLevelService.getAll().subscribe((orgs) => {
            this.organizationLevels = orgs;
            this.organizationsTree = toOrganizationTree(
                this.organizationLevels,
            );
        });
    }

    public trackById = trackById;
}
